/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { CanReviewResponse } from '../models/can-review-response';
import { CompanionItem } from '../models/companion-item';
import { CompanionsListResponse } from '../models/companions-list-response';
import { MyDonationsResponse } from '../models/my-donations-response';
import { ReviewsTourLeaderResponse } from '../models/reviews-tour-leader-response';
import { ReviewTourLeaderItem } from '../models/review-tour-leader-item';
import { TravelBookingCreateResponseRedirect } from '../models/travel-booking-create-response-redirect';
import { TravelAssignment } from '../models/travel-assignment';
import { TravelCategoriesList } from '../models/travel-categories-list';
import { travelControllerAcceptAssignment } from '../fn/travel/travel-controller-accept-assignment';
import { TravelControllerAcceptAssignment$Params } from '../fn/travel/travel-controller-accept-assignment';
import { travelControllerAddAttachment } from '../fn/travel/travel-controller-add-attachment';
import { TravelControllerAddAttachment$Params } from '../fn/travel/travel-controller-add-attachment';
import { travelControllerAddCountryPictureFromCloud } from '../fn/travel/travel-controller-add-country-picture-from-cloud';
import { TravelControllerAddCountryPictureFromCloud$Params } from '../fn/travel/travel-controller-add-country-picture-from-cloud';
import { travelControllerAddFavourite } from '../fn/travel/travel-controller-add-favourite';
import { TravelControllerAddFavourite$Params } from '../fn/travel/travel-controller-add-favourite';
import { travelControllerAddPicture } from '../fn/travel/travel-controller-add-picture';
import { TravelControllerAddPicture$Params } from '../fn/travel/travel-controller-add-picture';
import { travelControllerCount } from '../fn/travel/travel-controller-count';
import { TravelControllerCount$Params } from '../fn/travel/travel-controller-count';
import { travelControllerCountByCountries } from '../fn/travel/travel-controller-count-by-countries';
import { TravelControllerCountByCountries$Params } from '../fn/travel/travel-controller-count-by-countries';
import { travelControllerCreateAssignment } from '../fn/travel/travel-controller-create-assignment';
import { TravelControllerCreateAssignment$Params } from '../fn/travel/travel-controller-create-assignment';
import { travelControllerCreateCompanion } from '../fn/travel/travel-controller-create-companion';
import { TravelControllerCreateCompanion$Params } from '../fn/travel/travel-controller-create-companion';
import { travelControllerCreateDraft } from '../fn/travel/travel-controller-create-draft';
import { TravelControllerCreateDraft$Params } from '../fn/travel/travel-controller-create-draft';
import { travelControllerCreateFundingDraft } from '../fn/travel/travel-controller-create-funding-draft';
import { TravelControllerCreateFundingDraft$Params } from '../fn/travel/travel-controller-create-funding-draft';
import { travelControllerCreateReviewTourLeader } from '../fn/travel/travel-controller-create-review-tour-leader';
import { TravelControllerCreateReviewTourLeader$Params } from '../fn/travel/travel-controller-create-review-tour-leader';
import { travelControllerCreateTravelDonation } from '../fn/travel/travel-controller-create-travel-donation';
import { TravelControllerCreateTravelDonation$Params } from '../fn/travel/travel-controller-create-travel-donation';
import { travelControllerDeleteAttachment } from '../fn/travel/travel-controller-delete-attachment';
import { TravelControllerDeleteAttachment$Params } from '../fn/travel/travel-controller-delete-attachment';
import { travelControllerDeleteCompanion } from '../fn/travel/travel-controller-delete-companion';
import { TravelControllerDeleteCompanion$Params } from '../fn/travel/travel-controller-delete-companion';
import { travelControllerDeleteDraft } from '../fn/travel/travel-controller-delete-draft';
import { TravelControllerDeleteDraft$Params } from '../fn/travel/travel-controller-delete-draft';
import { travelControllerDeleteImage } from '../fn/travel/travel-controller-delete-image';
import { TravelControllerDeleteImage$Params } from '../fn/travel/travel-controller-delete-image';
import { travelControllerDeleteTravel } from '../fn/travel/travel-controller-delete-travel';
import { TravelControllerDeleteTravel$Params } from '../fn/travel/travel-controller-delete-travel';
import { travelControllerGetAll } from '../fn/travel/travel-controller-get-all';
import { TravelControllerGetAll$Params } from '../fn/travel/travel-controller-get-all';
import { travelControllerGetAllCompanions } from '../fn/travel/travel-controller-get-all-companions';
import { TravelControllerGetAllCompanions$Params } from '../fn/travel/travel-controller-get-all-companions';
import { travelControllerGetCategories } from '../fn/travel/travel-controller-get-categories';
import { TravelControllerGetCategories$Params } from '../fn/travel/travel-controller-get-categories';
import { travelControllerGetCompanion } from '../fn/travel/travel-controller-get-companion';
import { TravelControllerGetCompanion$Params } from '../fn/travel/travel-controller-get-companion';
import { travelControllerGetCompanionTravels } from '../fn/travel/travel-controller-get-companion-travels';
import { TravelControllerGetCompanionTravels$Params } from '../fn/travel/travel-controller-get-companion-travels';
import { travelControllerGetDraft } from '../fn/travel/travel-controller-get-draft';
import { TravelControllerGetDraft$Params } from '../fn/travel/travel-controller-get-draft';
import { travelControllerGetDrafts } from '../fn/travel/travel-controller-get-drafts';
import { TravelControllerGetDrafts$Params } from '../fn/travel/travel-controller-get-drafts';
import { travelControllerGetEarliest } from '../fn/travel/travel-controller-get-earliest';
import { TravelControllerGetEarliest$Params } from '../fn/travel/travel-controller-get-earliest';
import { travelControllerGetFavouriteTravels } from '../fn/travel/travel-controller-get-favourite-travels';
import { TravelControllerGetFavouriteTravels$Params } from '../fn/travel/travel-controller-get-favourite-travels';
import { travelControllerGetMyDonations } from '../fn/travel/travel-controller-get-my-donations';
import { TravelControllerGetMyDonations$Params } from '../fn/travel/travel-controller-get-my-donations';
import { travelControllerGetMyTravels } from '../fn/travel/travel-controller-get-my-travels';
import { TravelControllerGetMyTravels$Params } from '../fn/travel/travel-controller-get-my-travels';
import { travelControllerGetReviewsTourLeader } from '../fn/travel/travel-controller-get-reviews-tour-leader';
import { TravelControllerGetReviewsTourLeader$Params } from '../fn/travel/travel-controller-get-reviews-tour-leader';
import { travelControllerGetTourLeaderTravels } from '../fn/travel/travel-controller-get-tour-leader-travels';
import { TravelControllerGetTourLeaderTravels$Params } from '../fn/travel/travel-controller-get-tour-leader-travels';
import { travelControllerGetTravel } from '../fn/travel/travel-controller-get-travel';
import { TravelControllerGetTravel$Params } from '../fn/travel/travel-controller-get-travel';
import { travelControllerGetTravelDonations } from '../fn/travel/travel-controller-get-travel-donations';
import { TravelControllerGetTravelDonations$Params } from '../fn/travel/travel-controller-get-travel-donations';
import { travelControllerGetTravelQrCode } from '../fn/travel/travel-controller-get-travel-qr-code';
import { TravelControllerGetTravelQrCode$Params } from '../fn/travel/travel-controller-get-travel-qr-code';
import { travelControllerPublishDraft } from '../fn/travel/travel-controller-publish-draft';
import { TravelControllerPublishDraft$Params } from '../fn/travel/travel-controller-publish-draft';
import { travelControllerRejectAssignment } from '../fn/travel/travel-controller-reject-assignment';
import { TravelControllerRejectAssignment$Params } from '../fn/travel/travel-controller-reject-assignment';
import { travelControllerRemoveAllFavourites } from '../fn/travel/travel-controller-remove-all-favourites';
import { TravelControllerRemoveAllFavourites$Params } from '../fn/travel/travel-controller-remove-all-favourites';
import { travelControllerRemoveFavourite } from '../fn/travel/travel-controller-remove-favourite';
import { TravelControllerRemoveFavourite$Params } from '../fn/travel/travel-controller-remove-favourite';
import { travelControllerRevokeAssignment } from '../fn/travel/travel-controller-revoke-assignment';
import { TravelControllerRevokeAssignment$Params } from '../fn/travel/travel-controller-revoke-assignment';
import { travelControllerSaveDraft } from '../fn/travel/travel-controller-save-draft';
import { TravelControllerSaveDraft$Params } from '../fn/travel/travel-controller-save-draft';
import { travelControllerSaveTravel } from '../fn/travel/travel-controller-save-travel';
import { TravelControllerSaveTravel$Params } from '../fn/travel/travel-controller-save-travel';
import { travelControllerSetExtraCee } from '../fn/travel/travel-controller-set-extra-cee';
import { TravelControllerSetExtraCee$Params } from '../fn/travel/travel-controller-set-extra-cee';
import { travelControllerSortPictures } from '../fn/travel/travel-controller-sort-pictures';
import { TravelControllerSortPictures$Params } from '../fn/travel/travel-controller-sort-pictures';
import { travelControllerTopOne } from '../fn/travel/travel-controller-top-one';
import { TravelControllerTopOne$Params } from '../fn/travel/travel-controller-top-one';
import { travelControllerUpdateCompanion } from '../fn/travel/travel-controller-update-companion';
import { TravelControllerUpdateCompanion$Params } from '../fn/travel/travel-controller-update-companion';
import { travelControllerUserCanReviewTourLeader } from '../fn/travel/travel-controller-user-can-review-tour-leader';
import { TravelControllerUserCanReviewTourLeader$Params } from '../fn/travel/travel-controller-user-can-review-tour-leader';
import { TravelDonationsResponse } from '../models/travel-donations-response';
import { TravelDraft } from '../models/travel-draft';
import { TravelDraftId } from '../models/travel-draft-id';
import { TravelDraftMinimal } from '../models/travel-draft-minimal';
import { TravelItem } from '../models/travel-item';
import { TravelItemMinimalListResponse } from '../models/travel-item-minimal-list-response';
import { TravelItemMinimalListResponseWithoutCount } from '../models/travel-item-minimal-list-response-without-count';
import { TravelItemMinimalWithVisibilityMetadataListResponse } from '../models/travel-item-minimal-with-visibility-metadata-list-response';
import { TravelItemWithVisibilityMetadata } from '../models/travel-item-with-visibility-metadata';
import { TravelsCountByCountryResponse } from '../models/travels-count-by-country-response';
import { TravelsCountResponse } from '../models/travels-count-response';

@Injectable({ providedIn: 'root' })
export class TravelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `travelControllerGetDrafts()` */
  static readonly TravelControllerGetDraftsPath = '/travel/draft';

  /**
   * Restituisce l'elenco dei travel draft dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetDrafts()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetDrafts$Response(params: TravelControllerGetDrafts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>> {
    return travelControllerGetDrafts(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei travel draft dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetDrafts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetDrafts(params: TravelControllerGetDrafts$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}> {
    return this.travelControllerGetDrafts$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>): BaseResponse & {
'data'?: TravelItemMinimalListResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerCreateDraft()` */
  static readonly TravelControllerCreateDraftPath = '/travel/draft';

  /**
   * Crea un empty draft per il travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCreateDraft()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCreateDraft$Response(params?: TravelControllerCreateDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftId;
}>> {
    return travelControllerCreateDraft(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un empty draft per il travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCreateDraft$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCreateDraft(params?: TravelControllerCreateDraft$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraftId;
}> {
    return this.travelControllerCreateDraft$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftId;
}>): BaseResponse & {
'data'?: TravelDraftId;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerCreateFundingDraft()` */
  static readonly TravelControllerCreateFundingDraftPath = '/travel/draft-funding';

  /**
   * Crea un empty draft di tipo funding per il travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCreateFundingDraft()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCreateFundingDraft$Response(params?: TravelControllerCreateFundingDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftId;
}>> {
    return travelControllerCreateFundingDraft(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un empty draft di tipo funding per il travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCreateFundingDraft$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCreateFundingDraft(params?: TravelControllerCreateFundingDraft$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraftId;
}> {
    return this.travelControllerCreateFundingDraft$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftId;
}>): BaseResponse & {
'data'?: TravelDraftId;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetDraft()` */
  static readonly TravelControllerGetDraftPath = '/travel/draft/{id}';

  /**
   * Restituisce il draft del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetDraft()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetDraft$Response(params: TravelControllerGetDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>> {
    return travelControllerGetDraft(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il draft del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetDraft$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetDraft(params: TravelControllerGetDraft$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraft;
}> {
    return this.travelControllerGetDraft$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>): BaseResponse & {
'data'?: TravelDraft;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerPublishDraft()` */
  static readonly TravelControllerPublishDraftPath = '/travel/draft/{id}';

  /**
   * Pubblica il draft del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerPublishDraft()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerPublishDraft$Response(params: TravelControllerPublishDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>> {
    return travelControllerPublishDraft(this.http, this.rootUrl, params, context);
  }

  /**
   * Pubblica il draft del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerPublishDraft$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerPublishDraft(params: TravelControllerPublishDraft$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItem;
}> {
    return this.travelControllerPublishDraft$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>): BaseResponse & {
'data'?: TravelItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerDeleteDraft()` */
  static readonly TravelControllerDeleteDraftPath = '/travel/draft/{id}';

  /**
   * Elimina il draft del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerDeleteDraft()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteDraft$Response(params: TravelControllerDeleteDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>> {
    return travelControllerDeleteDraft(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina il draft del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerDeleteDraft$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteDraft(params: TravelControllerDeleteDraft$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraft;
}> {
    return this.travelControllerDeleteDraft$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>): BaseResponse & {
'data'?: TravelDraft;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerSaveDraft()` */
  static readonly TravelControllerSaveDraftPath = '/travel/draft/{id}';

  /**
   * Salva il draft del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerSaveDraft()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSaveDraft$Response(params: TravelControllerSaveDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>> {
    return travelControllerSaveDraft(this.http, this.rootUrl, params, context);
  }

  /**
   * Salva il draft del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerSaveDraft$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSaveDraft(params: TravelControllerSaveDraft$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraft;
}> {
    return this.travelControllerSaveDraft$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>): BaseResponse & {
'data'?: TravelDraft;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerCreateAssignment()` */
  static readonly TravelControllerCreateAssignmentPath = '/travel/draft/{id}/assign-request';

  /**
   * Crea una richiesta di assegnamento dal TL PRO al TL per il draft del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCreateAssignment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerCreateAssignment$Response(params: TravelControllerCreateAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>> {
    return travelControllerCreateAssignment(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una richiesta di assegnamento dal TL PRO al TL per il draft del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCreateAssignment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerCreateAssignment(params: TravelControllerCreateAssignment$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelAssignment;
}> {
    return this.travelControllerCreateAssignment$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>): BaseResponse & {
'data'?: TravelAssignment;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerAcceptAssignment()` */
  static readonly TravelControllerAcceptAssignmentPath = '/travel/draft/{id}/assign-request/{identifier}/accept';

  /**
   * Accetta una richiesta di assegnamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerAcceptAssignment()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerAcceptAssignment$Response(params: TravelControllerAcceptAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>> {
    return travelControllerAcceptAssignment(this.http, this.rootUrl, params, context);
  }

  /**
   * Accetta una richiesta di assegnamento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerAcceptAssignment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerAcceptAssignment(params: TravelControllerAcceptAssignment$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelAssignment;
}> {
    return this.travelControllerAcceptAssignment$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>): BaseResponse & {
'data'?: TravelAssignment;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerRejectAssignment()` */
  static readonly TravelControllerRejectAssignmentPath = '/travel/draft/{id}/assign-request/{identifier}/reject';

  /**
   * Rifiuta una richiesta di assegnamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerRejectAssignment()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRejectAssignment$Response(params: TravelControllerRejectAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>> {
    return travelControllerRejectAssignment(this.http, this.rootUrl, params, context);
  }

  /**
   * Rifiuta una richiesta di assegnamento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerRejectAssignment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRejectAssignment(params: TravelControllerRejectAssignment$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelAssignment;
}> {
    return this.travelControllerRejectAssignment$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>): BaseResponse & {
'data'?: TravelAssignment;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerRevokeAssignment()` */
  static readonly TravelControllerRevokeAssignmentPath = '/travel/draft/{id}/assign-request/{identifier}/revoke';

  /**
   * Revoca una richiesta di assegnamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerRevokeAssignment()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRevokeAssignment$Response(params: TravelControllerRevokeAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>> {
    return travelControllerRevokeAssignment(this.http, this.rootUrl, params, context);
  }

  /**
   * Revoca una richiesta di assegnamento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerRevokeAssignment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRevokeAssignment(params: TravelControllerRevokeAssignment$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelAssignment;
}> {
    return this.travelControllerRevokeAssignment$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>): BaseResponse & {
'data'?: TravelAssignment;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetCategories()` */
  static readonly TravelControllerGetCategoriesPath = '/travel/categories';

  /**
   * Restituisce l'elenco delle categorie.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetCategories$Response(params?: TravelControllerGetCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelCategoriesList;
}>> {
    return travelControllerGetCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle categorie.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetCategories(params?: TravelControllerGetCategories$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelCategoriesList;
}> {
    return this.travelControllerGetCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelCategoriesList;
}>): BaseResponse & {
'data'?: TravelCategoriesList;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetAllCompanions()` */
  static readonly TravelControllerGetAllCompanionsPath = '/travel/companion';

  /**
   * Restituisce l'elenco degli accompagnatori.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetAllCompanions()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetAllCompanions$Response(params: TravelControllerGetAllCompanions$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionsListResponse;
}>> {
    return travelControllerGetAllCompanions(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli accompagnatori.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetAllCompanions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetAllCompanions(params: TravelControllerGetAllCompanions$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanionsListResponse;
}> {
    return this.travelControllerGetAllCompanions$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanionsListResponse;
}>): BaseResponse & {
'data'?: CompanionsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerCreateCompanion()` */
  static readonly TravelControllerCreateCompanionPath = '/travel/companion';

  /**
   * Crea un accompagnatore.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCreateCompanion()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerCreateCompanion$Response(params: TravelControllerCreateCompanion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>> {
    return travelControllerCreateCompanion(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un accompagnatore.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCreateCompanion$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerCreateCompanion(params: TravelControllerCreateCompanion$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanionItem;
}> {
    return this.travelControllerCreateCompanion$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>): BaseResponse & {
'data'?: CompanionItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetCompanion()` */
  static readonly TravelControllerGetCompanionPath = '/travel/companion/{id}';

  /**
   * Restituisce un companion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetCompanion()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetCompanion$Response(params: TravelControllerGetCompanion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>> {
    return travelControllerGetCompanion(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un companion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetCompanion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetCompanion(params: TravelControllerGetCompanion$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanionItem;
}> {
    return this.travelControllerGetCompanion$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>): BaseResponse & {
'data'?: CompanionItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerDeleteCompanion()` */
  static readonly TravelControllerDeleteCompanionPath = '/travel/companion/{id}';

  /**
   * Elimina un companion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerDeleteCompanion()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteCompanion$Response(params: TravelControllerDeleteCompanion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>> {
    return travelControllerDeleteCompanion(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un companion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerDeleteCompanion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteCompanion(params: TravelControllerDeleteCompanion$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanionItem;
}> {
    return this.travelControllerDeleteCompanion$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>): BaseResponse & {
'data'?: CompanionItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerUpdateCompanion()` */
  static readonly TravelControllerUpdateCompanionPath = '/travel/companion/{id}';

  /**
   * Modifica un accompagnatore.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerUpdateCompanion()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerUpdateCompanion$Response(params: TravelControllerUpdateCompanion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>> {
    return travelControllerUpdateCompanion(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un accompagnatore.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerUpdateCompanion$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerUpdateCompanion(params: TravelControllerUpdateCompanion$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanionItem;
}> {
    return this.travelControllerUpdateCompanion$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>): BaseResponse & {
'data'?: CompanionItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetCompanionTravels()` */
  static readonly TravelControllerGetCompanionTravelsPath = '/travel/companion/{id}/travels';

  /**
   * Restituisce i travels di un companion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetCompanionTravels()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetCompanionTravels$Response(params: TravelControllerGetCompanionTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>> {
    return travelControllerGetCompanionTravels(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i travels di un companion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetCompanionTravels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetCompanionTravels(params: TravelControllerGetCompanionTravels$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}> {
    return this.travelControllerGetCompanionTravels$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>): BaseResponse & {
'data'?: TravelItemMinimalListResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetMyTravels()` */
  static readonly TravelControllerGetMyTravelsPath = '/travel/my';

  /**
   * Restituisce i travel pubblicati dall'utente del token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetMyTravels()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetMyTravels$Response(params: TravelControllerGetMyTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
}>> {
    return travelControllerGetMyTravels(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i travel pubblicati dall'utente del token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetMyTravels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetMyTravels(params: TravelControllerGetMyTravels$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
}> {
    return this.travelControllerGetMyTravels$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
}>): BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetTourLeaderTravels()` */
  static readonly TravelControllerGetTourLeaderTravelsPath = '/travel/organized-travels/{idTourLeader}';

  /**
   * Restituisce i travel pubblicati da un TL.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetTourLeaderTravels()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTourLeaderTravels$Response(params: TravelControllerGetTourLeaderTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
}>> {
    return travelControllerGetTourLeaderTravels(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i travel pubblicati da un TL.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetTourLeaderTravels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTourLeaderTravels(params: TravelControllerGetTourLeaderTravels$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
}> {
    return this.travelControllerGetTourLeaderTravels$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
}>): BaseResponse & {
'data'?: TravelItemMinimalWithVisibilityMetadataListResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetMyDonations()` */
  static readonly TravelControllerGetMyDonationsPath = '/travel/my-donations';

  /**
   * Restituisce i travel sui quali ho effettuato donazioni.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetMyDonations()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetMyDonations$Response(params?: TravelControllerGetMyDonations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MyDonationsResponse;
}>> {
    return travelControllerGetMyDonations(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i travel sui quali ho effettuato donazioni.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetMyDonations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetMyDonations(params?: TravelControllerGetMyDonations$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MyDonationsResponse;
}> {
    return this.travelControllerGetMyDonations$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MyDonationsResponse;
}>): BaseResponse & {
'data'?: MyDonationsResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetEarliest()` */
  static readonly TravelControllerGetEarliestPath = '/travel/earliest';

  /**
   * Restituisce l'elenco dei travel in partenza.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetEarliest()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetEarliest$Response(params: TravelControllerGetEarliest$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>> {
    return travelControllerGetEarliest(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei travel in partenza.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetEarliest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetEarliest(params: TravelControllerGetEarliest$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}> {
    return this.travelControllerGetEarliest$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>): BaseResponse & {
'data'?: TravelItemMinimalListResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerCount()` */
  static readonly TravelControllerCountPath = '/travel/count';

  /**
   * Restituisce il count di tutti i travels.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCount$Response(params?: TravelControllerCount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelsCountResponse;
}>> {
    return travelControllerCount(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il count di tutti i travels.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCount(params?: TravelControllerCount$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelsCountResponse;
}> {
    return this.travelControllerCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelsCountResponse;
}>): BaseResponse & {
'data'?: TravelsCountResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerCountByCountries()` */
  static readonly TravelControllerCountByCountriesPath = '/travel/count-by-country';

  /**
   * Restituisce il count di tutti i travels.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCountByCountries()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCountByCountries$Response(params?: TravelControllerCountByCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelsCountByCountryResponse;
}>> {
    return travelControllerCountByCountries(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il count di tutti i travels.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCountByCountries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerCountByCountries(params?: TravelControllerCountByCountries$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelsCountByCountryResponse;
}> {
    return this.travelControllerCountByCountries$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelsCountByCountryResponse;
}>): BaseResponse & {
'data'?: TravelsCountByCountryResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerTopOne()` */
  static readonly TravelControllerTopOnePath = '/travel/top-one';

  /**
   * Restituisce il travel con più bookings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerTopOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerTopOne$Response(params?: TravelControllerTopOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>> {
    return travelControllerTopOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il travel con più bookings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerTopOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerTopOne(params?: TravelControllerTopOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}> {
    return this.travelControllerTopOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>): BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerAddFavourite()` */
  static readonly TravelControllerAddFavouritePath = '/travel/fav/{id}';

  /**
   * Aggiunge un travel ai preferiti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerAddFavourite()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerAddFavourite$Response(params: TravelControllerAddFavourite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return travelControllerAddFavourite(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge un travel ai preferiti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerAddFavourite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerAddFavourite(params: TravelControllerAddFavourite$Params, context?: HttpContext): Observable<void> {
    return this.travelControllerAddFavourite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `travelControllerRemoveFavourite()` */
  static readonly TravelControllerRemoveFavouritePath = '/travel/fav/{id}';

  /**
   * Rimuove un travel dai preferiti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerRemoveFavourite()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRemoveFavourite$Response(params: TravelControllerRemoveFavourite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return travelControllerRemoveFavourite(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuove un travel dai preferiti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerRemoveFavourite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRemoveFavourite(params: TravelControllerRemoveFavourite$Params, context?: HttpContext): Observable<void> {
    return this.travelControllerRemoveFavourite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `travelControllerGetFavouriteTravels()` */
  static readonly TravelControllerGetFavouriteTravelsPath = '/travel/fav';

  /**
   * Restituisce i travel preferiti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetFavouriteTravels()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetFavouriteTravels$Response(params?: TravelControllerGetFavouriteTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponseWithoutCount;
}>> {
    return travelControllerGetFavouriteTravels(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i travel preferiti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetFavouriteTravels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetFavouriteTravels(params?: TravelControllerGetFavouriteTravels$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemMinimalListResponseWithoutCount;
}> {
    return this.travelControllerGetFavouriteTravels$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponseWithoutCount;
}>): BaseResponse & {
'data'?: TravelItemMinimalListResponseWithoutCount;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerRemoveAllFavourites()` */
  static readonly TravelControllerRemoveAllFavouritesPath = '/travel/fav';

  /**
   * Rimuove tutti i travel dai preferiti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerRemoveAllFavourites()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRemoveAllFavourites$Response(params: TravelControllerRemoveAllFavourites$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return travelControllerRemoveAllFavourites(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuove tutti i travel dai preferiti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerRemoveAllFavourites$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerRemoveAllFavourites(params: TravelControllerRemoveAllFavourites$Params, context?: HttpContext): Observable<void> {
    return this.travelControllerRemoveAllFavourites$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `travelControllerUserCanReviewTourLeader()` */
  static readonly TravelControllerUserCanReviewTourLeaderPath = '/travel/reviews/tour-leader/{tour_leader_id}/can_review';

  /**
   * Valuta se l'utente può recensire il tour leader.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerUserCanReviewTourLeader()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerUserCanReviewTourLeader$Response(params: TravelControllerUserCanReviewTourLeader$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CanReviewResponse;
}>> {
    return travelControllerUserCanReviewTourLeader(this.http, this.rootUrl, params, context);
  }

  /**
   * Valuta se l'utente può recensire il tour leader.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerUserCanReviewTourLeader$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerUserCanReviewTourLeader(params: TravelControllerUserCanReviewTourLeader$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CanReviewResponse;
}> {
    return this.travelControllerUserCanReviewTourLeader$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CanReviewResponse;
}>): BaseResponse & {
'data'?: CanReviewResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetReviewsTourLeader()` */
  static readonly TravelControllerGetReviewsTourLeaderPath = '/travel/reviews/tour-leader/{tour_leader_id}';

  /**
   * Restituisce le recensioni del tour leader.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetReviewsTourLeader()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetReviewsTourLeader$Response(params: TravelControllerGetReviewsTourLeader$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ReviewsTourLeaderResponse;
}>> {
    return travelControllerGetReviewsTourLeader(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le recensioni del tour leader.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetReviewsTourLeader$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetReviewsTourLeader(params: TravelControllerGetReviewsTourLeader$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ReviewsTourLeaderResponse;
}> {
    return this.travelControllerGetReviewsTourLeader$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ReviewsTourLeaderResponse;
}>): BaseResponse & {
'data'?: ReviewsTourLeaderResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerCreateReviewTourLeader()` */
  static readonly TravelControllerCreateReviewTourLeaderPath = '/travel/reviews/tour-leader/{tour_leader_id}';

  /**
   * Crea una recensione per il tour leader.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCreateReviewTourLeader()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerCreateReviewTourLeader$Response(params: TravelControllerCreateReviewTourLeader$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ReviewTourLeaderItem;
}>> {
    return travelControllerCreateReviewTourLeader(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una recensione per il tour leader.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCreateReviewTourLeader$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerCreateReviewTourLeader(params: TravelControllerCreateReviewTourLeader$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ReviewTourLeaderItem;
}> {
    return this.travelControllerCreateReviewTourLeader$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ReviewTourLeaderItem;
}>): BaseResponse & {
'data'?: ReviewTourLeaderItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetTravel()` */
  static readonly TravelControllerGetTravelPath = '/travel/{id}';

  /**
   * Restituisce il travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetTravel()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTravel$Response(params: TravelControllerGetTravel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>> {
    return travelControllerGetTravel(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetTravel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTravel(params: TravelControllerGetTravel$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}> {
    return this.travelControllerGetTravel$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>): BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerDeleteTravel()` */
  static readonly TravelControllerDeleteTravelPath = '/travel/{id}';

  /**
   * Elimina il travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerDeleteTravel()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteTravel$Response(params: TravelControllerDeleteTravel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>> {
    return travelControllerDeleteTravel(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina il travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerDeleteTravel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteTravel(params: TravelControllerDeleteTravel$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}> {
    return this.travelControllerDeleteTravel$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>): BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerSaveTravel()` */
  static readonly TravelControllerSaveTravelPath = '/travel/{id}';

  /**
   * Modifica il travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerSaveTravel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSaveTravel$Response(params: TravelControllerSaveTravel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>> {
    return travelControllerSaveTravel(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica il travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerSaveTravel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSaveTravel(params: TravelControllerSaveTravel$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItem;
}> {
    return this.travelControllerSaveTravel$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>): BaseResponse & {
'data'?: TravelItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetTravelQrCode()` */
  static readonly TravelControllerGetTravelQrCodePath = '/travel/{id}/qrcode';

  /**
   * Restituisce il QRCode del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetTravelQrCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTravelQrCode$Response(params: TravelControllerGetTravelQrCode$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return travelControllerGetTravelQrCode(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il QRCode del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetTravelQrCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTravelQrCode(params: TravelControllerGetTravelQrCode$Params, context?: HttpContext): Observable<Blob> {
    return this.travelControllerGetTravelQrCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `travelControllerCreateTravelDonation()` */
  static readonly TravelControllerCreateTravelDonationPath = '/travel/{id}/donate';

  /**
   * Crea una donazione per il travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerCreateTravelDonation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerCreateTravelDonation$Response(params: TravelControllerCreateTravelDonation$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
    return travelControllerCreateTravelDonation(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una donazione per il travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerCreateTravelDonation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerCreateTravelDonation(params: TravelControllerCreateTravelDonation$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}> {
    return this.travelControllerCreateTravelDonation$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>): BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerGetTravelDonations()` */
  static readonly TravelControllerGetTravelDonationsPath = '/travel/{id}/donations';

  /**
   * Restituisce le donazioni del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetTravelDonations()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTravelDonations$Response(params: TravelControllerGetTravelDonations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDonationsResponse;
}>> {
    return travelControllerGetTravelDonations(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le donazioni del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetTravelDonations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetTravelDonations(params: TravelControllerGetTravelDonations$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDonationsResponse;
}> {
    return this.travelControllerGetTravelDonations$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDonationsResponse;
}>): BaseResponse & {
'data'?: TravelDonationsResponse;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerSetExtraCee()` */
  static readonly TravelControllerSetExtraCeePath = '/travel/{id}/extra_cee';

  /**
   * Modifica il flag extra_cee del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerSetExtraCee()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSetExtraCee$Response(params: TravelControllerSetExtraCee$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>> {
    return travelControllerSetExtraCee(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica il flag extra_cee del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerSetExtraCee$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSetExtraCee(params: TravelControllerSetExtraCee$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItem;
}> {
    return this.travelControllerSetExtraCee$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>): BaseResponse & {
'data'?: TravelItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerAddPicture()` */
  static readonly TravelControllerAddPicturePath = '/travel/{id}/picture';

  /**
   * Aggiunge una foto al travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerAddPicture()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerAddPicture$Response(params: TravelControllerAddPicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>> {
    return travelControllerAddPicture(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge una foto al travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerAddPicture$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerAddPicture(params: TravelControllerAddPicture$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraftMinimal;
}> {
    return this.travelControllerAddPicture$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>): BaseResponse & {
'data'?: TravelDraftMinimal;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerAddCountryPictureFromCloud()` */
  static readonly TravelControllerAddCountryPictureFromCloudPath = '/travel/{id}/picture-from-cloud';

  /**
   * Foto per il Travel dal cloud.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerAddCountryPictureFromCloud()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerAddCountryPictureFromCloud$Response(params: TravelControllerAddCountryPictureFromCloud$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>> {
    return travelControllerAddCountryPictureFromCloud(this.http, this.rootUrl, params, context);
  }

  /**
   * Foto per il Travel dal cloud.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerAddCountryPictureFromCloud$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerAddCountryPictureFromCloud(params: TravelControllerAddCountryPictureFromCloud$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraftMinimal;
}> {
    return this.travelControllerAddCountryPictureFromCloud$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>): BaseResponse & {
'data'?: TravelDraftMinimal;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerSortPictures()` */
  static readonly TravelControllerSortPicturesPath = '/travel/{id}/picture/sort';

  /**
   * Riordina le foto per il Travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerSortPictures()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSortPictures$Response(params: TravelControllerSortPictures$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>> {
    return travelControllerSortPictures(this.http, this.rootUrl, params, context);
  }

  /**
   * Riordina le foto per il Travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerSortPictures$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  travelControllerSortPictures(params: TravelControllerSortPictures$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelDraftMinimal;
}> {
    return this.travelControllerSortPictures$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>): BaseResponse & {
'data'?: TravelDraftMinimal;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerDeleteImage()` */
  static readonly TravelControllerDeleteImagePath = '/travel/{id}/picture/{media_id}';

  /**
   * Elimina la foto del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerDeleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteImage$Response(params: TravelControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return travelControllerDeleteImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina la foto del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerDeleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteImage(params: TravelControllerDeleteImage$Params, context?: HttpContext): Observable<void> {
    return this.travelControllerDeleteImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `travelControllerAddAttachment()` */
  static readonly TravelControllerAddAttachmentPath = '/travel/{id}/attachment';

  /**
   * Aggiunge un allegato al travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerAddAttachment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerAddAttachment$Response(params: TravelControllerAddAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>> {
    return travelControllerAddAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge un allegato al travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerAddAttachment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  travelControllerAddAttachment(params: TravelControllerAddAttachment$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItem;
}> {
    return this.travelControllerAddAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>): BaseResponse & {
'data'?: TravelItem;
} => r.body)
    );
  }

  /** Path part for operation `travelControllerDeleteAttachment()` */
  static readonly TravelControllerDeleteAttachmentPath = '/travel/{id}/attachment/{media_id}';

  /**
   * Elimina l'allegato del travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerDeleteAttachment()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteAttachment$Response(params: TravelControllerDeleteAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return travelControllerDeleteAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina l'allegato del travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerDeleteAttachment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerDeleteAttachment(params: TravelControllerDeleteAttachment$Params, context?: HttpContext): Observable<void> {
    return this.travelControllerDeleteAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `travelControllerGetAll()` */
  static readonly TravelControllerGetAllPath = '/travel';

  /**
   * Restituisce l'elenco dei travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `travelControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetAll$Response(params: TravelControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>> {
    return travelControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `travelControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  travelControllerGetAll(params: TravelControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}> {
    return this.travelControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>): BaseResponse & {
'data'?: TravelItemMinimalListResponse;
} => r.body)
    );
  }

}
